module.exports = __webpack_public_path__ + "img/o_co_jde.101f7235.jpg";